import { call, put, select } from 'redux-saga/effects';

import {
  AUTHENTICATE_USER_REQUESTED,
  AUTHENTICATE_USER_SUCCEEDED,
  AUTHENTICATE_USER_ERRORED,
  FETCH_USER_SUCCEEDED,
  FETCH_USER_ERRORED,
} from 'config/types/action';

import getLocale from 'selectors/getLocale';
import lazyApiClient from 'services/babbelApi/apiClient';
import fetchCurrentUser from 'services/babbelApi/currentUser';

// eslint-disable-next-line import/prefer-default-export
export function* fetchUser() {
  try {
    yield put({ type: AUTHENTICATE_USER_REQUESTED });
    const apiClient = yield call(lazyApiClient);
    const uuid = yield call(apiClient.authenticate.bind(apiClient));
    yield put({ type: AUTHENTICATE_USER_SUCCEEDED, payload: { uuid } });
  } catch (error) {
    yield put({ type: AUTHENTICATE_USER_ERRORED, payload: error });
  }
  try {
    const locale = yield select(getLocale);
    const userData = yield call(fetchCurrentUser, { locale });
    yield put({ type: FETCH_USER_SUCCEEDED, payload: userData });
  } catch (error) {
    yield put({ type: FETCH_USER_ERRORED, payload: error });
  }
}

